import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  events: {
    title: string,
    location: string,
    details?: string,
    date: string,
    link?: string
  }[]  = [
    {
      "title": "🧰 InWebo Technologies : Ingénieur R&D / Développeur Front-end",
      "details": "Visual Studio Code - Node.js - Typescript - Angular - Bootstrap - HTML/SCSS - GITLAB - CI/CD - SCRUM - KARMA / JASMINE - JIRA",
      "location": "Paris",
      "date": "2021 - aujourd'hui"
    },
    {
      "title": "🎄 Calendrier de l'avent 🎅",
      "details": "Vue.JS / HTML / SCSS",
      "location": "Paris",
      "date": "12/2022",
      "link": "/project/adventcalendar"
    },
    {
      "title": "⚓️ Le Gargantua",
      "details": "Wordpress / HTML / CSS / Illustrator",
      "date": "2020",
      "location": "Paris",
      "link": "/project/gargantua-chinon"
    },
    {
      "title":"✈️ Royal Air Maroc : Graphic designer",
      "details": "Fashion Design/Uniforms - Illustrator - Photoshop - Indesign - Technical Drawing",
      "location": "Paris, France - Casablanca, Marocco",
      "date": "2019",
      "link": "/project/RAM"
    },
    {
      "title": "🖼️ Artefact.space",
      "details": "Node.js - Express.js - MongoDB - TypeScript - HTML/SCSS",
      "location": "Paris",
      "date": "2019 ",
      "link": "/project/artefact"
    },
    {
      "title": "🧰 Estimeo : Développeur front-end",
      "details": "Node.js - Express.js - Typescript - Angular - HTML/SCSS - Karma/Jasmine - GITHUB - Bootstrap - Figma - Indesign - Illustrator",
      "location": "Paris",
      "date": "2018",
      "link": "/project/estimeo"
    },
    {
      "title": "🧰 Singlespot : Creative Technologist",
      "details": "Node.js - Gulp - GIT - HTML/CSS - Javascript - Mobile - Photoshop - Illustrator",
      "location": "Paris",
      "date": "2017",
      "link": "/project/singlespot"
    },
    {
      "title": "🧰 Le BIPE -> BDO : designer/developer front-end <br><br>🧰 Le BIPE -> BDO Webdesigner (apprentissage)",
      "details": "Wordpress - PHP/MYSQL - HTML/CSS - Javascript - jQuery - GreenSock - RStudio - Play! Framework - Java/Scala - Illustrator - Indesign - Photoshop - Adobe XD - GITLAB",
      "location": "Issy-les-Moulineaux",
      "date": "2015 - 2017",
      "link": "/project/lebipe"
    },
    {
      "title": "🖼️🎥🎧 TrackID - Exposition - Festival I Love Transmédia",
      "details": "Node.js - Express.js - Mustache - Github - Javascript - HTML/SCSS",
      "location": "Gaîté Lyrique, Paris",
      "date": "2016 "
    },
    {
      "title": "🎓👩🏻‍🚀 Licence Chef de projet marketing internet & conception de sites",
      "details": "Adobe XD - Illustrator - Photoshop - Javascript - PHP/MYSQL - HTML/CSS - Gestion Projet - Marketing - UI/UX - Wordpress - Prestashop",
      "location": "Campus de la fonderie de l’image, Bagnolet ",
      "date": "2016"
    },
    {
      "title": "🧰 Intervenant Extérieur (freelance)",
      "details": "Présentation des métiers de l'industrie tech. auprès des élèves de terminale",
      "location": "Lycée Choiseul, Tours",
      "date": "2015"
    },
    {
      "title": "🧰 Avenir-Jeune (freelance)",
      "location": "Chaumont / Paris",
      "details": "Wordpress - PHP/MYSQL - HTML/CSS",
      "date": "2015",
      "link": "/static/wwwEGJ_maquette/"
    },
    {
      "title": "🧰 Santour (freelance)",
      "location": "Chaumont / Paris",
      "details": "HTML/CSS",
      "date": "2015",
      "link": "https://web.archive.org/web/20151210025303/http://santour.fr/"
    },
    {
      "title": "🎓🎨 BTS (Brevet Technicien Supérieur) Design graphique options médias numériques",
      "details": "HTML/CSS - Javascript - After Effect - Indesign - Illustrator - Photoshop - Photographie - Vidéo - Stop Motion - Dessin - Édition numérique/print - Reliure - Histoire de l'art - Application Ipad",
      "location": "Lycée Charles de Gaulle, Chaumont",
      "date": "2015",
      "link": "/static/wwwD3jsTuto/"
    },
    {
      "title": "🧰 BuzzleMe -> InterviewApp (stage)",
      "details": "HTML3/CSS5 - After Effect - Illustrator",
      "location": "Tours",
      "date": "2013"
    },
    {
      "title": "🎓🎨 Baccalauréat STI (Sciences et Technologies de l’Industrie) Arts Appliqués",
      "details": "After Effect - Illustrator - Photoshop - InDesign",
      "location": "Lycée Choiseul, Tours",
      "date": "2012"
    },
    {
      "title": "👔 Bombaeuro",
      "details": "HTML/CSS - PHP/MYSQL",
      "location": undefined,
      "date": "2007",
      "link": "https://web.archive.org/web/20070119085923/http://www.bombaeuro.com/"
    },
    {
      "title": "😃 Emoland",
      "details": "HTML/CSS - Javascript - PHP/MYSQL",
      "location": undefined,
      "date": "2006",
      "link": "https://web.archive.org/web/20060514095307/http://www.emoland.net/"
    },
    {
      "title": "🧠 Dreamweaver - PHP/MYSQL - Flash / ActionScript",
      "location": undefined,
      "date": undefined
    },
    {
      "title": "🧠 FrontPage - HTML / CSS / Javascript",
      "location": undefined,
      "date": undefined
    },
    {
      "title": "💻 1er Ordinateur",
      "details": "Microsoft Window 95",
      "location": undefined,
      "date": "1999"
    },
    {
      "title": "👩🏻‍🚀 Naissance",
      "location": undefined,
      "date": "1994"
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
